import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  getPubMissionBingoList,
  SellerBingoSizeFilter,
  SellerPubMissionBingoListItemResponse,
  SellerPubMissionBingoStatusFilter,
} from "../../../api/pub-mission-bingo";
import { pubState } from "../../../recoil/pub.atom";

const LIMIT = 10;

export const useEventBingo = () => {
  const pub = useRecoilValue(pubState);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [bingoList, setBingoList] = useState<
    SellerPubMissionBingoListItemResponse[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sizeFilter, setSizeFilter] = useState<SellerBingoSizeFilter>(
    SellerBingoSizeFilter.ALL,
  );
  const [statusFilter, setStatusFilter] =
    useState<SellerPubMissionBingoStatusFilter>(
      SellerPubMissionBingoStatusFilter.ALL,
    );

  const handleSearchQueryChange = useCallback((query: string) => {
    setSearchQuery(query);
    setCurrentPage(1);
  }, []);

  const handleSizeFilterChange = useCallback((size: SellerBingoSizeFilter) => {
    setSizeFilter(size);
    setCurrentPage(1);
  }, []);

  const handleStatusFilterChange = useCallback(
    (status: SellerPubMissionBingoStatusFilter) => {
      setStatusFilter(status);
      setCurrentPage(1);
    },
    [],
  );

  const fetchBingoList = useCallback(async () => {
    if (!pub) return;

    const res = await getPubMissionBingoList({
      pubId: pub.id,
      page: currentPage,
      limit: LIMIT,
      name: searchQuery || undefined,
      size:
        sizeFilter === SellerBingoSizeFilter.ALL ? undefined : sizeFilter,
      status:
        statusFilter === SellerPubMissionBingoStatusFilter.ALL
          ? undefined
          : statusFilter,
    });

    setBingoList(res.list);
    setTotalCount(res.total);
    setTotalPages(Math.max(1, Math.ceil(res.total / LIMIT)));
  }, [pub, currentPage, searchQuery, sizeFilter, statusFilter]);

  useEffect(() => {
    fetchBingoList();
  }, [fetchBingoList]);

  return {
    pubId: pub?.id ?? 0,
    currentPage,
    setCurrentPage,
    totalPages,
    totalCount,
    bingoList,
    searchQuery,
    sizeFilter,
    statusFilter,
    handleSearchQueryChange,
    handleSizeFilterChange,
    handleStatusFilterChange,
    refreshBingoList: fetchBingoList,
  };
};
